<template>
    <div class="headerclass">
         <div v-if="!loggedIn">
           <img alt="school logo" :src="LogoPath"  class="loginlogo" >
         </div>
         
         <div v-if="loggedIn" class="horizFlexStretch">
            <div class="vertFlexTop leftjustified">
              <img alt="school logo" :src="LogoPath"  class="logo" v-if="LogoPath!=''">
              <label class="headertextbold">{{loggedInUser.LocationName}}</label>
           </div>
           <div v-if="needsUpdate">
              <p class="update">Updates are available for your application. Please click Refresh to download the latest version.</p>
              <button @click="refreshapp()">Refresh</button>
          </div>
           <div class="vertFlexTop rightjustified" v-if="requireLogin">
            <div class="horizFlex">
              <button @click="openCashDrawer()" v-if="showCashDrawerButton" class="drawerbutton">Open Drawer</button>
              <label class="headertextbold">{{loggedInUser.name}}</label>
            </div> 
           
             <linkbutton class="logoutButton" toplabel="Logout" @click="logout()" />
              <label for="locationselect" class="sr-only">Location</label>
               <select name="" id="locationselect" class='entrySelect selaccount' v-model="location.id"  @change="selectLocation()" v-if="!locationAndTerminalPreselected">
                  <option v-for="loc in LocationList" :key="loc.id" :value="loc.id" >
                      {{loc.name}}
                  </option>
              </select>
              <label for="terminalselect" class="sr-only">Terminal</label>
              <select name="" id="terminalselect" class='entrySelect selaccount' v-model="terminalId"  v-if="location.maxTerminalId>0 && !locationAndTerminalPreselected" @change="selectLocation()" >
                  <option v-for="t in terminalList" :key="t.id" :value="t.id" >
                      {{t.name}}
                  </option>
              </select>
  
              <label class="headertext" v-if="locationAndTerminalPreselected">{{location.name}}</label>
              <label class="headertext" v-if="locationAndTerminalPreselected">Terminal {{terminalId}}</label>
  
              
  
              
           </div>
         </div>
         <div v-if="loggedIn" class="horizFlexStretch">
          <div class="suspendbuttons">
            <transactions :showButton="trueParam"  v-if="ShowTransactions" buttonClass="shortbutton"/>
            <giftcardbalance :showButton="trueParam" v-if="showGiftcard" buttonClass="shortbutton"/>
            <accountbalance :showButton="trueParam" v-if="showAccount" buttonClass="shortbutton"/>

          </div>
          
          <div class="topmessage">
            <label class="responsemessage topmessagelabel">{{responseMessage}}</label>
            <div class="margin10">
              <linkbutton  toplabel="Refresh" v-if="businessDayId==-1" @click="selectLocation"/>
            </div>
           </div>
          <div class="suspendbuttons">
                <confirm :showButton="trueParam" :body="getSuspendString()" title="Suspend Ticket" @yes="suspendticket" v-if="ShowSuspended" buttonclass="shortbutton"/>
                <suspendedtickets :showButton="trueParam" @gototicket="gototicket" @removeticket="removeticket" v-if="ShowSuspended" buttonClass="shortbutton"/>
            </div>
          </div>  
      </div>
  </template>
  
  <script>

   import {mapFields} from 'vuex-map-fields'
   import linkbutton from '../controls/linkbutton.vue'
   import suspendedtickets from '../actions/suspendedtickets.vue'
   import transactions from '../actions/transactions.vue'
   import confirm from '../actions/confirm.vue'
   import giftcardbalance from '../actions/giftcardbalance.vue'
   import accountbalance from '../actions/accountbalance.vue'
   import pos from '../../services/pos.js'
    import pay from '../../services/pay.js'
    import printreceipthelper from '../../services/printreceipthelper.js'
  export default {
      name:'header_default',
      components:{
          linkbutton,
          suspendedtickets,
          confirm,
          transactions,
          giftcardbalance,
          accountbalance,
      },
       mixins:[pos,pay,printreceipthelper],
      computed:{
          ...mapFields([
              'loggedInUser',
              'loggedIn',
              'requireLogin',
              'location',
              'pleaseWait',
              'responseMessage',
            
              'needsUpdate',

          ]),
          

      },
      data(){
          return{
              
              falseParam:false,
              trueParam:true
          }
      },
      methods:{
        refreshapp(){
              location.reload(true);
        },

      },
      mounted(){
          this.getLocations();
      }
  }
  </script>
  
  <style>
  .headerclass{
    background-color:var(--header-color);
   
  }
  .suspendbuttons{
    padding-bottom:10px;
    display:flex;
    flex-direction:row;
  }
  .vertFlexTop{
    display:flex;
    flex-direction: column;
    margin:5px;
    align-items: top;
  }
  .logo{
        height:70px;
    }
    .loginlogo{
        height:80px;
        margin-right:0px;
        margin-top:10px;
      }
      .shortbutton{
        border: none;
        border-radius:10px;
        width:135px;
        height:40px;
        padding:0px;
        font-size: medium;
        margin:10px;
        text-decoration: none;
        background-color:var( --button-color);
        color:var(--button-text-color);
  
      }
      .topmessage{
        display:flex;
        flex-direction: row;
        align-items:center
      }
      .topmessagelabel{
        vertical-align: middle;
      }
      .drawerbutton{
        border: none;
        border-radius:10px;
        width:110px;
        height:25px;
        padding:0px;
        font-size: medium;
        margin-right:10px;
        text-decoration: none;
        background-color:var( --button-color);
        color:var(--button-text-color);
      }
 
  </style>